import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-warn-error',
  templateUrl: './warn-error.component.html',
  styleUrls: ['./warn-error.component.scss'],
})
export class WarnErrorComponent implements OnInit {

  color: string;
  icon: string;
  message: string;
  type: IssueType;

  @Input() set warnErrorIssue(value: WarnError) {
    this.message = value.message;
    this.type = value.type === "error" ? "error" : "warning";
    switch (this.type) {
      case 'error':
        this.color = '#e72e3e';
        this.icon = '/assets/icons/error-triangle.svg';
        break;
      case 'warning':
        this.color = '#f87900';
        this.icon = '/assets/icons/alert-circle.svg';
        break;
      default: break;
    }
  }

  ngOnInit() { }
}

export type IssueType = "warning" | "error";
export interface WarnError {
  type: IssueType;
  message: string;
}
